import React, { useState, useEffect, useRef, useContext, useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import IconButton from '@mui/material/IconButton';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import DetailsPageCard from '../../common/DetailsPage/DetailsPageCard';
import CustomModal from '../../../components/common/CustomModal';
import CreateSalesOrder from "../CreateForm/CreateSalesOrder";
import UpdateSalesOrder from '../UpdateForm/UpdateSalesOrder';
import MessageBox from '../../common/CustomMessageBox';
import CustomDelete from '../../common/CustomDeleteAlert';
import { useExportShipmentDetails } from './Hook/useExportShipmentDetails';
import { DELETE_SALES_ORDER_EXPORT, GET_PRODUCTS_LIST, GET_SUPPLIERS_LIST, LIST_SALES_ORDERS_EXPORT } from '../../../services/apiRoutes'; // Updated to match the sales orders API route
import { genericPost } from '../../../services/authServices';
import axios from 'axios';
import SalesOrderView from '../ViewDetails/SalesOrderView';
import CustomLoader from '../../common/CustomLoader';
import { AuthContext } from '../../../context/AuthContext';
import LoyaltyOutlinedIcon from '@mui/icons-material/LoyaltyOutlined';
import { getCurrencyList, getRoundAmount } from '../../../services/CommonServices';
import { useCompanyDateFormat } from "../../../constants/useCompanyDateFormat";


const SalesOrder = ({ fetchButtonList }) => {
    const { token } = useContext(AuthContext)
    const companyDateFormat = useCompanyDateFormat();
    const [open, setOpen] = useState(true);
    const [modal, setModal] = useState(false);
    const [updateModal, setUpdateModal] = useState(false);
    const [activeTab, setActiveTab] = useState('Sales Order');
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [message, setMessage] = useState({ open: false, text: '', type: '' });
    const [salesOrderId, setSalesOrderId] = useState('');
    const [customerList, setCustomerList] = useState([]);
    const [products, setProducts] = useState([]);
    const [viewModal, setViewModal] = useState(false);
    const [currencyList, setCurrencyList] = useState([]);
    const [deleteAlert, setDeleteAlert] = useState(false)
    const [rowId, setRowId] = useState('')

    const navigate = useNavigate();
    const { exportShipmentId } = useParams();
    const { shipmentDetails, loading: shipmentLoading } = useExportShipmentDetails(exportShipmentId);


    let customerId, cifFob;
    const hasFetched = useRef(false);
    useEffect(() => {
        if (shipmentDetails) {
            customerId = shipmentDetails.customerId;
            cifFob = shipmentDetails.cifFob.cifFobName;
            getCommonData();
            fetchData();
            fetchProductsList();
            getCustomersList();
            hasFetched.current = true;
        }
    }, [shipmentDetails, updateModal, salesOrderId, deleteAlert, token, modal]);


    const fetchProductsList = async () => {
        const authToken = sessionStorage.getItem('accessToken');
        const payload = {
            clientCompanyId: customerId,
        };

        try {
            const response = await axios.post(GET_PRODUCTS_LIST, payload, {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                },
            });

            if (response.status === 200 && response.data.success) {
                const productData = response.data.productsList;
                console.log(productData);
                setProducts(productData);
            } else {
                console.error('Failed to fetch products list:', response.data);
            }
        } catch (error) {
            console.error('Error fetching products list:', error);
        }
    };


    const getCustomersList = async () => {
        try {
            const payload = {
                clientCompanyId: customerId,
            };

            const response = await genericPost(GET_SUPPLIERS_LIST, payload, {
            });

            if (response.data && response.data.success && response.data.clientCompanies) {
                const customersData = response.data.clientCompanies.map((customer) => ({
                    id: customer.clientCompanyId,
                    title: customer.clientCompanyName,
                }));
                setCustomerList(customersData);

            } else {
                return [];
            }
        } catch (error) {
            console.error('Error fetching customer list:', error);
            return [];
        }
    };
    const getCommonData = async () => {
        const currencyListData = await getCurrencyList();
        setCurrencyList(currencyListData);
    }
    const fetchData = async () => {
        setLoading(true);
        try {
            const payload = {
                // customerNamesId: customerId,
                customerNamesId: customerName,
                shipmentId: shipmentId
            };
            const response = await genericPost(LIST_SALES_ORDERS_EXPORT, payload);

            if (response.data.success) {
                const salesOrders = response.data.data.map((order, index) => {
                    const particulars = order.particulars.map((particular) => ({
                        qty: particular.qty || 0,
                        rate: parseFloat(particular.rate) || 0,
                        amount: (particular.qty || 0) * (parseFloat(particular.rate) || 0),
                    }));

                    // const totalAmount = particulars.reduce((total, { amount }) => total + amount, 0);
                    const totalAmount = getRoundAmount(particulars.reduce((total, { amount }) => total + amount, 0));
                    return {
                        salesOrderId: order.salesOrderId || '',
                        index: (index + 1).toString().padStart(2, '0'),
                        userId: order.userId || '',
                        companyId: order.companyId || '',
                        customerName: order.customer.clientCompanyName || '',
                        country: order?.customer?.billingCountry?.name || '',
                        reference: order.reference || '',
                        salesOrderNo: `${expSalesPrefix || ''} ${order.salesOrderNo || ''} ${expSalesSuffix || ''}`,
                        clientCompanyName: order.customer?.clientCompanyName || '',
                        dueDate: companyDateFormat(order?.dueDate) || '',
                        date: companyDateFormat(order?.date) || '',
                        note: order.note || '',
                        createdAt: order.createdAt || '',
                        updatedAt: order.updatedAt || '',
                        particulars,
                        shipmentIdName: order.shipmentId || '',
                        totalAmount: `${order.currency?.currency_symbol || ''} ${totalAmount ? totalAmount.toFixed(2) : ""}`,
                    };
                });
                setData(salesOrders);
            } else {
                setError('No sales orders found');
            }
        } catch (error) {
            setError('Error fetching sales orders');
            console.error('Error fetching sales orders', error);
        } finally {
            setLoading(false);
        }
    };



    const handleDelete = async (salesOrderId) => {
        setLoading(true);
        const authToken = sessionStorage.getItem('accessToken');

        try {
            const response = await axios.delete(DELETE_SALES_ORDER_EXPORT(salesOrderId), {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                },
            });

            if (response.status === 200) {
                setDeleteAlert(false);
                fetchButtonList();
                fetchData();
                setMessage({
                    open: true,
                    text: "deleted successfully",
                    type: "success",
                });
            } else {
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);

            if (error.response) {
                if (error.response.status === 409) {
                    setMessage({
                        open: true,
                        text: error.response.data?.error || "Cannot delete Data. Related Shipment exists.",
                        type: "error",
                    });
                } else {
                    setMessage({
                        open: true,
                        text: "An error occurred while deleting the Data.",
                        type: "error",
                    });
                }
            } else {
                console.error("Error deleting Data", error);
                setMessage({
                    open: true,
                    text: "Network error. Please try again later.",
                    type: "error",
                });
            }
        }
    };


    // Table columns
    const columns = [
        {
            accessor: 'index', label: 'SN', id: 'index', styleAccessor: {
                textAlign: 'center', maxWidth: '200px', width: "50px"
            },
        },
        {
            id: 'salesOrderNo', label: 'Sales Order No.', accessor: 'salesOrderNo', styleAccessor: {
                textAlign: 'center',
            },
        },
        {
            id: 'date', label: 'Date', accessor: 'date', styleAccessor: {
                textAlign: 'center',
            },
        },

        {
            id: 'shipmentIdName', label: 'Shipping Id', accessor: 'shipmentIdName', styleAccessor: {
                textAlign: 'center',
            },
        },

        { id: 'clientCompanyName', label: 'Customer Name', accessor: 'clientCompanyName' },
        {
            id: 'totalAmount', label: 'Amount', accessor: 'totalAmount', styleAccessor: {
                textAlign: 'right',
            },
        },
        {
            id: 'action',
            label: 'Action',
            accessor: 'action',
            Cell: ({ row }) => (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '1px' }}>
                    <IconButton onClick={() => handleViewClick(row.salesOrderId)} style={{ marginRight: '1px' }}>
                        <VisibilityIcon style={{ color: '#059212' }} />
                    </IconButton>
                    <IconButton onClick={() => handleUpdateClick(row.salesOrderId)} style={{ marginRight: '1px' }}>
                        <ModeEditOutlineOutlinedIcon style={{ color: '#050C9C' }} />
                    </IconButton>
                    <IconButton onClick={() => handleOpenDeleteAlert(row.salesOrderId)}>
                        <DeleteOutlineOutlinedIcon style={{ color: '#E4003A' }} />
                    </IconButton>
                </div>
            ),
        },
    ];

    const handleViewClick = (id) => {
        setSalesOrderId(id);
        setViewModal(true);
    };

    const handleCloseView = () => {
        setViewModal(false);
        setSalesOrderId('');
    };

    const handleUpdateClick = (id) => {
        setSalesOrderId(id);
        setUpdateModal(true);
    };
    const handleOpenDeleteAlert = (rowId) => {
        setDeleteAlert(true)
        setRowId(rowId)
    }


    const handleOpen = () => {
        setModal(true);
    };

    const handleClose = () => {
        setModal(false);
    };

    const handleCloseUpdate = () => {
        setUpdateModal(false);
        setSalesOrderId('');
    };


    if (!shipmentDetails) {
        return <div> <CustomLoader open={shipmentLoading} />   </div>;
    }

    const expSalesPrefixActivity = shipmentDetails.company.expSalesPrefixActivity ?? '';
    const expSalesPrefix = (expSalesPrefixActivity === 1)
        ? shipmentDetails.company.expSalesPrefix
        : (expSalesPrefixActivity === 0 ? '' : '');

    const expSalesSuffixActivity = shipmentDetails.company.expSalesSuffixActivity ?? '';
    const expSalesSuffix = (expSalesSuffixActivity === 1)
        ? shipmentDetails.company.expSalesSuffix
        : (expSalesSuffixActivity === 0 ? '' : '');

    const companyName = shipmentDetails.customer.clientCompanyName;
    const phoneNumber = shipmentDetails.customer.mobile;
    const customerName = shipmentDetails.customerId;
    const shipmentId = shipmentDetails.shipmentId;
    const shipmentOrgId = shipmentDetails.exportShipmentId;
    const currencySymbol = shipmentDetails?.currency?.currency_symbol ?? '';
    const currencyShort = shipmentDetails?.currency?.currency ?? '';
    const currencyId = shipmentDetails?.currency?.id ?? '';
    const templateId = shipmentDetails?.company?.templateId ?? '1';


    // JSX Structure
    return (
        <div>
            <CustomLoader open={loading} />
            <DetailsPageCard
                Icon={LoyaltyOutlinedIcon}
                columns={columns}
                title="Sales Order"
                buttonTitle="Create Sales Order"
                handleOpen={handleOpen}
                data={data}
                loading={loading}
                error={error}
            />
            <CustomModal open={modal}  >
                <CreateSalesOrder
                    fetchData={fetchData}
                    customerList={customerList}
                    productsList={products}
                    customerName={customerName}
                    shipmentId={shipmentId}
                    setMessage={setMessage}
                    currencyList={currencyList}
                    currencyId={currencyId}
                    currencySymbol={currencySymbol}
                    expSalesPrefix={expSalesPrefix}
                    expSalesSuffix={expSalesSuffix}
                    shipmentOrgId={shipmentOrgId}
                    fetchButtonList={fetchButtonList}
                    handleClose={handleClose} />
            </CustomModal>

            <CustomModal open={updateModal}  >
                <UpdateSalesOrder
                    fetchData={fetchData}
                    customerList={customerList}
                    productsList={products}
                    setMessage={setMessage}
                    handleClose={handleCloseUpdate}
                    salesOrderId={salesOrderId}
                    currencyList={currencyList}
                    expSalesPrefix={expSalesPrefix}
                    expSalesSuffix={expSalesSuffix}
                />
            </CustomModal>
            <CustomModal open={viewModal} handleClose={handleCloseView}>
                <SalesOrderView
                    fetchData={fetchData}
                    customerList={customerList}
                    productsList={products}
                    setMessage={setMessage}
                    handleClose={handleCloseView}
                    salesOrderId={salesOrderId}
                    expSalesPrefix={expSalesPrefix}
                    expSalesSuffix={expSalesSuffix}
                    templateId={templateId}
                    shipmentOrgId={shipmentOrgId}
                />
            </CustomModal>

            <MessageBox
                open={message.open}
                onClose={() => setMessage({ ...message, open: false })}
                message={message.text}
                handleClose={() => setMessage({ ...message, open: false })}
                type={message.type}
            />
            <CustomDelete
                handleDelete={handleDelete}
                open={deleteAlert}
                rowId={rowId}
                handleClose={() => setDeleteAlert(false)}
            />
        </div>
    );
};

export default SalesOrder;
